import { createContext, useEffect, useState } from 'react';

import { Settings, SettingsContextValue, SettingsProviderProps } from './props';
import { initialSettings, restoreSettings, storeSettings } from './settings';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SettingsContext = createContext<SettingsContextValue>({
  saveSettings: () => null,
  settings: initialSettings,
});

export const SettingsConsumer = SettingsContext.Consumer;
export const SettingsProvider: React.FC<SettingsProviderProps> = (props) => {
  const { children, pageSettings } = props;

  // =============== STATE
  const [settings, setSettings] = useState<Settings>({ ...initialSettings });

  // =============== EFFECTS
  useEffect(() => {
    const restoredSettings = restoreSettings();
    if (restoredSettings) {
      setSettings({ ...restoredSettings });
    }
    if (pageSettings) {
      setSettings({ ...settings, ...pageSettings });
    }
  }, [pageSettings]);

  useEffect(() => {
    const layout = settings.layout;
    const isHorizontal = layout === 'horizontal';
    if (isHorizontal && settings.mode === 'semi-dark') {
      saveSettings({ ...settings, mode: 'light' });
    }
    if (isHorizontal && settings.appBar === 'hidden') {
      saveSettings({ ...settings, appBar: 'fixed' });
    }
  }, [settings.layout]);

  // =============== HELPERS
  const saveSettings = (updatedSettings: Settings) => {
    storeSettings(updatedSettings);
    setSettings(updatedSettings);
  };

  // =============== VIEWS
  return (
    <SettingsContext.Provider value={{ settings, saveSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
